import { render, staticRenderFns } from "./ConsolidatedIgnoredAccounts.vue?vue&type=template&id=78259144&scoped=true"
import script from "./ConsolidatedIgnoredAccounts.vue?vue&type=script&lang=js"
export * from "./ConsolidatedIgnoredAccounts.vue?vue&type=script&lang=js"
import style0 from "./ConsolidatedIgnoredAccounts.vue?vue&type=style&index=0&id=78259144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78259144",
  null
  
)

export default component.exports